// extracted by mini-css-extract-plugin
module.exports = {"loader-wrapper":"Loader_loader-wrapper__1hOyb","box-loader":"Loader_box-loader__vq4i5"};